import React from 'react';
import PropTypes from 'prop-types';
export function AlertMessageModal({ show, onClose, model }) {

    const handleOverlayClick = (e) => {
        if (e.target.className === 'admin-modal-overlay') {
            onClose();
        }
    };

    if (!show) {
        return null;
    }
    return (
        <div className="admin-modal-overlay" onClick={handleOverlayClick}>
            <div className="admin-modal">
                <button className="admin-modal-close" onClick={onClose}>
                    <span className="material-symbols-rounded">close</span>
                </button>
                <h2 className="admin-modal-heading">
                    {model?.title}
                </h2>
                <div className="">
                    <div className="admin-modal-cell">{model?.message}</div>
                    <div className="admin-modal-cell">{model?.description}</div>
                </div>
            </div>
        </div>
    );
}

AlertMessageModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    model: PropTypes.object
};